import styled from 'styled-components'

export const Container = styled.main`
  position: relative;
  z-index: 0;
  max-width: 1100px;
  padding: 6rem 2.4rem 8rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 7rem;
  overflow-x: hidden;

  @media (min-width: 1200px) {
    max-width: 1180px;
  }

  @media (max-width: 768px) {
    padding: 4.8rem 1.8rem 6rem;
    gap: 6rem;
  }

  @media (max-width: 480px) {
    padding: 4rem 1.6rem 5rem;
  }
`
